import tokenData from '../../design-tokens/base-tokens.json';
import { ChevronDown as ChevronDownIcon } from 'mdi-material-ui';
export const MuiDateTimePicker = {
    defaultProps: {
        components: {
            SwitchViewIcon: ChevronDownIcon
        },
        closeOnSelect: false
    }
};
export const MuiDatePicker = {
    defaultProps: {
        components: {
            SwitchViewIcon: ChevronDownIcon
        }
    }
};
export const MuiPickersCalendarHeader = {
    defaultProps: {
        components: {
            SwitchViewIcon: ChevronDownIcon
        }
    },
    styleOverrides: {
        root: ({ theme }) => ({
            marginTop: theme.spacing(4),
            marginBottom: 2,
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6)
        }),
        label: {
            color: tokenData.tokens.palette.text.text300,
            fontWeight: 600
        },
        labelContainer: {
            overflow: 'visible'
        },
        switchViewButton: {
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.grey.grey100
            },
            '& .MuiPickersCalendarHeader-switchViewIcon': {
                color: tokenData.tokens.palette.text.text200
            }
        }
    }
};
export const MuiYearPicker = {
    styleOverrides: {
        root: {
            '& .PrivatePickersYear-root': {
                '& .PrivatePickersYear-yearButton': {
                    background: 'transparent',
                    fontSize: tokenData.tokens.typography.body.fontSize,
                    color: tokenData.tokens.palette.text.text300,
                    '&.Mui-selected': {
                        backgroundColor: tokenData.tokens.palette.blue.blue500
                    },
                    '&:focus': {
                        backgroundColor: tokenData.tokens.palette.blue.blue100,
                        outline: '2px solid black',
                        outlineOffset: '1px',
                        '&.Mui-selected': {
                            backgroundColor: tokenData.tokens.palette.blue.blue500
                        }
                    }
                }
            }
        }
    }
};
export const MuiYearCalendar = {
    styleOverrides: {
        root: {
            backgroundColor: tokenData.tokens.palette.background.white
        }
    }
};
export const MuiPickersYear = {
    styleOverrides: {
        yearButton: {
            borderRadius: 24,
            padding: 6,
            '&.Mui-selected': {
                backgroundColor: tokenData.tokens.palette.blue.blue500,
                color: tokenData.tokens.palette.background.white,
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.blue.blue100,
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '&:focus': {
                backgroundColor: tokenData.tokens.palette.blue.blue100,
                outline: '2px solid black',
                outlineOffset: '1px',
                '&.Mui-selected': {
                    backgroundColor: tokenData.tokens.palette.blue.blue500,
                    color: tokenData.tokens.palette.background.white,
                    '&:hover': {
                        backgroundColor: tokenData.tokens.palette.blue.blue500,
                        color: tokenData.tokens.palette.background.white
                    }
                }
            },
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.blue.blue100,
                color: tokenData.tokens.palette.text.text300
            },
            '&:Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            }
        }
    }
};
export const MuiPickersArrowSwitcher = {
    styleOverrides: {
        root: {
            '& .MuiPickersArrowSwitcher-button': {
                fontSize: 18,
                padding: 4,
                margin: 0,
                color: tokenData.tokens.palette.text.text200,
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.grey.grey100
                }
            }
        }
    }
};
export const MuiPickersMonth = {
    styleOverrides: {
        monthButton: {
            color: tokenData.tokens.palette.text.text300,
            '&.Mui-selected': {
                backgroundColor: tokenData.tokens.palette.blue.blue500,
                color: tokenData.tokens.palette.background.white,
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.blue.blue100,
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '&:focus': {
                backgroundColor: tokenData.tokens.palette.blue.blue100,
                outline: '2px solid black',
                outlineOffset: '1px',
                '&.Mui-selected': {
                    backgroundColor: tokenData.tokens.palette.blue.blue500,
                    color: tokenData.tokens.palette.background.white,
                    '&:hover': {
                        backgroundColor: tokenData.tokens.palette.blue.blue500,
                        color: tokenData.tokens.palette.background.white
                    }
                }
            },
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.blue.blue100,
                color: tokenData.tokens.palette.text.text300
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            }
        }
    }
};
export const MuiDayCalendar = {
    styleOverrides: {
        header: {
            backgroundColor: tokenData.tokens.palette.background.white
        },
        slideTransition: {
            backgroundColor: tokenData.tokens.palette.background.white
        },
        weekDayLabel: ({ theme }) => ({
            color: tokenData.tokens.palette.text.text100,
            ...theme.typography.caption
        }),
        monthContainer: ({ theme }) => ({
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        })
    }
};
export const MuiPickersDay = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: tokenData.tokens.palette.text.text300,
            ...theme.typography.body1,
            '&.Mui-disabled': {
                color: `${tokenData.tokens.palette.grey.disabled} !important`
            },
            '&.Mui-selected': {
                backgroundColor: tokenData.tokens.palette.blue.blue500,
                color: tokenData.tokens.palette.background.white,
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.blue.blue100,
                    color: tokenData.tokens.palette.text.text300
                }
            },
            '&:focus': {
                backgroundColor: tokenData.tokens.palette.blue.blue100,
                outline: '2px solid black',
                outlineOffset: '1px',
                '&.Mui-selected': {
                    backgroundColor: tokenData.tokens.palette.blue.blue500,
                    color: tokenData.tokens.palette.background.white,
                    '&:hover': {
                        backgroundColor: tokenData.tokens.palette.blue.blue500,
                        color: tokenData.tokens.palette.background.white
                    }
                }
            },
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.blue.blue100
            }
        }),
        today: {
            borderColor: `${tokenData.tokens.palette.darkBlue.darkBlue300} !important`
        }
    }
};
export const MuiMultiInputDateRangeField = {
    styleOverrides: {
        root: {
            alignItems: 'center'
        }
    }
};
export const MuiDateRangePickerDay = {
    styleOverrides: {
        root: {
            '&:last-of-type': {
                '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
                    borderRightColor: tokenData.tokens.palette.darkBlue.darkBlue300
                }
            },
            '&:first-of-type': {
                '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
                    borderLeftColor: tokenData.tokens.palette.darkBlue.darkBlue300
                }
            }
        },
        rangeIntervalDayPreview: {
            borderTopColor: tokenData.tokens.palette.darkBlue.darkBlue300,
            borderBottomColor: tokenData.tokens.palette.darkBlue.darkBlue300
        },
        rangeIntervalDayHighlight: {
            backgroundColor: tokenData.tokens.palette.darkBlue.darkBlue100
        },
        day: {
            '&.Mui-selected': {
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.blue.blue100,
                    color: tokenData.tokens.palette.text.text300,
                    outline: '2px solid black'
                }
            },
            '&.Mui-disabled': {
                color: `${tokenData.tokens.palette.grey.disabled} !important`
            }
        },
        dayInsideRangeInterval: {
            '&&:hover': {
                outline: '2px solid black',
                color: `${tokenData.tokens.palette.text.text300} !important`
            }
        },
        outsideCurrentMonth: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
                border: 'none'
            }
        },
        lastVisibleCell: {
            '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
                borderRightColor: tokenData.tokens.palette.darkBlue.darkBlue300
            }
        },
        firstVisibleCell: {
            '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
                borderLeftColor: tokenData.tokens.palette.darkBlue.darkBlue300
            }
        }
    }
};
export const MuiPickersLayout = {
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiDialogActions-root': {
                backgroundColor: tokenData.tokens.palette.background.white
            },
            '& .MuiPickersLayout-actionBar': {
                padding: theme.spacing(4, 6)
            }
        })
    }
};
export const MuiDatePickerToolbar = {
    defaultProps: {
        toolbarPlaceholder: '- -'
    }
};
export const MuiPickersToolbar = {
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiTypography-overline': {
                ...theme.typography.body,
                color: tokenData.tokens.palette.text.text300,
                textTransform: 'none'
            },
            '&.MuiDatePickerToolbar-root': {
                padding: theme.spacing(2, 6)
            },
            '&.MuiDateRangePickerToolbar-root': {
                padding: theme.spacing(2, 6)
            }
        }),
        content: ({ theme }) => ({
            '& .MuiTypography-root': {
                ...theme.typography.labelLg,
                color: tokenData.tokens.palette.text.text300
            }
        })
    }
};
export const MuiMultiSectionDigitalClock = {
    styleOverrides: {
        root: {
            color: tokenData.tokens.palette.text.text300,
            '& .MuiList-root': {
                '& > li': {
                    fontWeight: 400,
                    borderRadius: '6px',
                    '&:hover': {
                        backgroundColor: `${tokenData.tokens.palette.blue.blue100} !important`
                    },
                    '&.Mui-focusVisible': {
                        backgroundColor: `${tokenData.tokens.palette.blue.blue100} !important`,
                        outline: '2px solid black',
                        borderRadius: '6px',
                        WebkitBorderRadius: '6px'
                    },
                    '&.Mui-selected:not(.Mui-disabled)': {
                        color: `${tokenData.tokens.palette.background.white} !important`,
                        backgroundColor: `${tokenData.tokens.palette.blue.blue500} !important`
                    },
                    '&.Mui-disabled': {
                        color: `${tokenData.tokens.palette.grey.disabled} !important`
                    }
                }
            }
        }
    }
};
